module.exports = __webpack_public_path__ + "img/arrow-right-custom.c9f83438.svg";